import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const block: ContentBlock<"checklist"> = {
  id: makeId("checklist-from-couch"),
  kind: "checklist",
  tags: ["pre-cycle", "at-home", "testing"],
  title: "FROM YOUR COUCH",
  icon: "🏠",
  body: {
    items: [
      {
        id: "genetic",
        label: "Genetic screening for both of you",
        detail:
          "Two options: standard carrier panel (~$250) or whole genome sequencing (~$500). Most clinics require this before proceeding.",
        tags: [
          { label: "Both partners", colorKey: "blue" },
          { label: "Swab kit", colorKey: "green" },
        ],
      },
      {
        id: "semen",
        label: "Semen analysis",
        detail:
          "Checks count, motility, morphology. At-home kits cost ~$100-200. Results in a few days.",
        tags: [
          { label: "His test", colorKey: "blue" },
          { label: "At-home option", colorKey: "green" },
        ],
      },
      {
        id: "amh",
        label: "AMH blood test",
        detail:
          "Anti-Mullerian Hormone tells you roughly how many eggs you have left. Not a quality measure  - just quantity.",
        tags: [
          { label: "Her test", colorKey: "coral" },
          { label: "At-home option", colorKey: "green" },
        ],
      },
      {
        id: "tracking",
        label: "Start cycle tracking",
        detail:
          "Your clinic will need to know your cycle length and regularity. Any tracking app works.",
        tags: [
          { label: "Her", colorKey: "coral" },
          { label: "Start now", colorKey: "warm" },
        ],
      },
    ],
  },
};

registerBlock(block);
